import React from "react";

const SkeletonLoader = ({
  width = "100%",
  height = "1rem",
  borderRadius = "8px",
  className = "",
  style = {},
}) => {
  return (
    <div
      className={`skeleton-loader${className ? ` ${className}` : ""}`}
      style={{ width, height, borderRadius, ...style }}
      aria-hidden="true"
    />
  );
};

export const SkeletonCircle = ({
  size = "40px",
  className = "",
  style = {},
}) => (
  <SkeletonLoader
    width={size}
    height={size}
    borderRadius="50%"
    className={className}
    style={style}
  />
);

export default SkeletonLoader;
